import { render, staticRenderFns } from "./FolderBadge.vue?vue&type=template&id=5b5dc58b"
import script from "./FolderBadge.vue?vue&type=script&lang=js"
export * from "./FolderBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports